import React from "react";
import PropTypes from "prop-types";

import colors from "core/colors";
import { DismissContainer } from "./styles";

import CloseIcon from "core/ReusableIcons/Close";

const CloseButton = ({ bannerDismiss }) => {
    return (
        <DismissContainer onClick={bannerDismiss} title="Dismiss banner">
            <CloseIcon size="md" fillColor={colors.secondary.orca} />
        </DismissContainer>
    );
};

CloseButton.propTypes = {
    bannerDismiss: PropTypes.func
};

export default CloseButton;
